import { render, staticRenderFns } from "./Boleto_UUID.vue?vue&type=template&id=3d28879e&scoped=true"
import script from "./Boleto_UUID.vue?vue&type=script&lang=js"
export * from "./Boleto_UUID.vue?vue&type=script&lang=js"
import style0 from "./Boleto_UUID.vue?vue&type=style&index=0&id=3d28879e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d28879e",
  null
  
)

export default component.exports